import React from 'react';
import ReactDOM from 'react-dom';
import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';
import StringUtil from '../utils/StringUtil';
import GOTUtil from '../utils/GOTUtil';
import QueryUtil from '../utils/QueryUtil';
import Warn from '../utils/Warn';
import GOTXML2Json from '../remote/GOTXML2Json';
import UserFormUtil from '../utils/UserFormUtil';
import UserSetFormTree from './UserSetFormTree';
import UserSetListDataGrid from './UserSetListDataGrid';
import UserSetFormPropertyPanel from './UserSetFormPropertyPanel';
import Fade from '../utils/Fade';
import CommandActions from '../actions/CommandActions'

require('../styles/UserFormSetForm.css')

export default class UserFormSetForm extends React.Component{
	constructor(props, context) {
    	super(props, context);
    	this.noSetLabel = "当前无默认值";
    	var _parentWindow = window.parent.window;
		if(!_parentWindow.userProperties)
		{
			_parentWindow.userProperties = {};
		}

		if(!_parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			_parentWindow.userProperties[window.menuItemId+"."+window.formId] = {};
		}
		this.state = {columnWidthProperties:null};
    }

	closeUserSetForm=()=>{
		let $reactComponentContainer = $("#userFormSetDiv");
		ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
		//$reactComponentContainer.remove();
		$("#userFormSetDiv").css("display","none");
	}

	reqUserSetForm()
	{
		var _parentWindow = window.parent.window;
		var allUserProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
		Object.assign(allUserProperties,this.propertyPanel.allUserProperties);
		if(!_parentWindow.userSetForms)
			_parentWindow.userSetForms = {};
		_parentWindow.userSetForms[window.menuItemId+"."+window.formId] = this.formTree.userSetForm;

		_parentWindow.reOpenCurrentForm();
		//this.closeUserSetForm();
	}

	resetForm()
	{
		var _parentWindow = window.parent.window;
		_parentWindow.userProperties[window.menuItemId+"."+window.formId] = {};
		if(!_parentWindow.userSetForms)
			_parentWindow.userSetForms = {};
		_parentWindow.userSetForms[window.menuItemId+"."+window.formId] = window.formXML;

		_parentWindow.reOpenCurrentForm();
	}
	resetColProperties(){
		let columnWidthProperties = {};
		CommandActions.getColumnLengthProperties(columnWidthProperties);
		this.setState({columnWidthProperties:columnWidthProperties})
	}

	componentDidMount()
	{
		$('body').mLoading("hide");
		$(this.outterDiv).draggable({
			handle: ".modal-header" // 只能点击头部拖动
		});
		$(this.userFormSetSaveDiv).draggable({
			handle: ".modal-header" // 只能点击头部拖动
		});
		
	}

	hideUserFormSetSaveTable()
	{
		$('#userFormSetSaveModal').hide();
	}

	parseForm2UserForm(root)
	{
		var parent = this.parseForm2UserFormItem(root);
		for(let i = 0;i<root.FormItem.length;i++)
		{
			let item = root.FormItem[i];
			parent.appendChild(this.parseForm2UserForm(item));
		}
		return parent;
	}
	
	parseForm2UserFormItem(item)
	{
		var innerId = item.id;

		var _parentWindow = window.parent.window;
		var properties;

		if(_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			properties = _userProperties[innerId];
		}
		if(!properties)properties = {};
		var allUserProperties = this.propertyPanel.allUserProperties;
		if(allUserProperties.hasOwnProperty(innerId))
		{
			Object.assign(properties,allUserProperties[innerId]);
		}
		
		var node = document.createElement("node");
		node.setAttribute("id",innerId);
		for(var key in properties)
		{
			node.setAttribute(key,properties[key]);
		}
		return node;
	}

	save(arg)
	{
		//this.saveScope = arg;
		$("#userFormSetSaveModal").show();
	}

	saveUserSetForm()
	{
		var formDesignXML = this.formTree.userSetForm.FormDesign;
		var userForm = this.parseForm2UserForm(formDesignXML);

		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"saveUserFormDesign", 
			"boolean"
		);
		
		let slipper = ".";
		if(window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1)
			slipper = "&";

		command.appendArg(window.formId+slipper+window.menuItemId);

		var setDefault_all=$(this.userSetDefaultBoxAll).prop("checked");
	
		if(setDefault_all)
		{
			/*var command = Command.createService( "gongqi.erp.gotmodel.services.UserSettingService", "saveUserProperties", "boolean");
		
			command.appendArg(userId); //ClientSession.getClientSessionInstance().userId
			command.appendArg(ugse,"gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity");*/
			command.appendArg('_default');
		}
		else
		{
			var _parentWindow = window.parent.window;
			command.appendArg(_parentWindow.userInfos.userId);
		}
		
				
		let fileName = $('#userSetFormSaveFileName').val();
		if(fileName != null && fileName != "")
			command.appendArg(fileName);
		else
			command.appendArg("test");

		command.appendArg(new XMLSerializer().serializeToString(userForm));
		var setDefault=$("#userSetDefaultBox").prop("checked");
		command.appendArg(setDefault, "boolean");
		ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_saveUserSetHandler.bind(this,setDefault)});
	}

	rpc_saveUserSetHandler(_default,data)
	{
		if(data.result == true)
		{	
			this.hideUserFormSetSaveTable();
			var options={
				state:'success'
			}
			Fade.show(options);
			// Warn.show({text:"保存成功"});
		}
		else
		{
			this.hideUserFormSetSaveTable();
			var options = {
			  state: 'error'
			}
			Fade.show(options);
		}
		if(_default)
		{
			var _parentWindow = window.parent.window;
			var allUserProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			Object.assign(allUserProperties,this.propertyPanel.allUserProperties);
			if(!_parentWindow.userSetForms)
				_parentWindow.userSetForms = {};
			_parentWindow.userSetForms[window.menuItemId+"."+window.formId] = this.formTree.userSetForm;
		}
	}

	

	btnLoadDefault_clickHandler(event)
	{
		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"loadUserDefaultFormDesign", 
			"String"
		);
		let slipper = ".";
		if(window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1)
			slipper = "&";
		command.appendArg(window.formId+slipper+window.menuItemId);
		var _parentWindow = window.parent.window;
		command.appendArg(_parentWindow.userInfos.userId)
		
		ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_loadDefaultSetHandler.bind(this)});
	}

	rpc_loadDefaultSetHandler(data)
	{
		var xmls = data.result;
		if(xmls)
		{

			let getxml = new DOMParser();
            let xmlDoc = getxml.parseFromString(xmls,"text/xml");
            let origFormXMLDoc = window.origFormXMLDoc.cloneNode(true);
			let mergedXML = UserFormUtil.mergeXML(xmlDoc.documentElement,origFormXMLDoc,null);
			let _parentWindow = window.parent.window;
			if(!_parentWindow.userProperties)
            	_parentWindow.userProperties = {};
          	_parentWindow.userProperties[window.menuItemId+"."+window.formId] = {};
            let _userFormXML = GOTUtil.parseUserForm2Form(origFormXMLDoc,mergedXML);
            let formDesign = origFormXMLDoc.children[2];
            origFormXMLDoc.removeChild(formDesign);
            origFormXMLDoc.appendChild(_userFormXML);
            let _userSetForm = GOTXML2Json.parseForm(origFormXMLDoc);
            
            if(!_parentWindow.userSetForms)_parentWindow.userSetForms = {};
            _parentWindow.userSetForms[window.menuItemId + "." + window.formId] = _userSetForm;
            _parentWindow.reOpenCurrentForm();
			
		}
		else
		{
			Warn.show({text:"加载失败"});
		}
	}

	showUserSetForm()
	{
		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"getUserFormDesignsWithDefault", 
			"List"
		);
		let slipper = ".";
		if(window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1)
			slipper = "&";
		command.appendArg(window.formId+slipper+window.menuItemId);
		var _parentWindow = window.parent.window;
		command.appendArg(_parentWindow.userInfos.userId);	
		var remoteArg = {command:command,resultFunction:this.rpc_getListHandler.bind(this),sync:false};
		ServiceHelper.addTokenWithCommand(remoteArg)
	}

	rpc_getListHandler(data)
	{
		var result=data.result;
		var listRows=[];

		for(var i=1;i<result.length;i++)
		{
			var listRow={};
			var item=result[i];
			var itemArr=item.split(" ");
			listRow['userName']=itemArr[0];
			listRow['fileName']=itemArr[1];
			listRows.push(listRow);
		}
		this.userSetList.setState({rows:listRows});
		var defaultItem;
		if(result[0]){
			defaultItem=result[0].split(" ")[1];
		}
		
		this.userSetTableTitle(defaultItem);
		$("#userSetTable").show();
	}


	userSetTableTitle=(defaultItem)=>{
	
		if(defaultItem){
			$("#userSetListDefaultItem").text("当前默认值 "+defaultItem).attr("name",defaultItem);
			$("#cancelUserSetListDefaultItem").show();
		}else{
			$("#userSetListDefaultItem").text(this.noSetLabel);
			$("#cancelUserSetListDefaultItem").hide();
		}
	}

	hideUserSetTable()
	{
		$("#userSetTable").hide();
	}

	//删除
	deleteUserSetList=()=>{
		let obj = this.userSetList.deleteRow();
		if(obj.row)
		{
			var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"deleteUserFormDesign", 
			"void"
			);
								
			var _parentWindow = window.parent.window;
			let slipper = ".";
			if(window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1)
				slipper = "&";
			command.appendArg(window.formId + slipper + window.menuItemId);
			command.appendArg(_parentWindow.userInfos.userId);
			command.appendArg(obj.row.fileName);
			var remoteArg = {command:command,resultFunction:this.rpc_deleteUserSetListHandler.bind(this,obj),
							 sync:false,faultFunction:this.fault_deleteUserSetListHandler.bind(this,obj)};
			ServiceHelper.addTokenWithCommand(remoteArg);	
		}
	}

	rpc_deleteUserSetListHandler(arg,data)
	{
		let row = arg.row;
		let delDefault = (row.fileName == $("#userSetListDefaultItem").attr("name"));
		if(delDefault)
		{
			$("#userSetListDefaultItem").text(this.noSetLabel);
			$("#cancelUserSetListDefaultItem").hide();
		}
		
	}

	resetUserSetTable=()=>{
		let selectedItem = this.userSetList.getSelectedRow();
		
		var userId = selectedItem.userName;
		var fileName = selectedItem.fileName;
		var methodName;
		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"loadUserFormDesign", 
			"String"
		);
		let slipper = ".";
		if(window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1)
			slipper = "&";
		command.appendArg(window.formId + slipper + window.menuItemId);
		command.appendArg(userId);
		command.appendArg(fileName);
		
		ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_loadHandler.bind(this)});
	}

	rpc_loadHandler(data)
	{
		var xmls = data.result;
		if(xmls)
		{

			let getxml = new DOMParser();
            let xmlDoc = getxml.parseFromString(xmls,"text/xml");
            let origFormXMLDoc = window.origFormXMLDoc.cloneNode(true);
			let mergedXML = UserFormUtil.mergeXML(xmlDoc.documentElement,origFormXMLDoc,null);
			let _parentWindow = window.parent.window;
			if(!_parentWindow.userProperties)
            	_parentWindow.userProperties = {};
          	_parentWindow.userProperties[window.menuItemId+"."+window.formId] = {};
            let _userFormXML = GOTUtil.parseUserForm2Form(origFormXMLDoc,mergedXML);
            let formDesign = origFormXMLDoc.children[2];
            origFormXMLDoc.removeChild(formDesign);
            origFormXMLDoc.appendChild(_userFormXML);
            let _userSetForm = GOTXML2Json.parseForm(origFormXMLDoc);
           
            if(!_parentWindow.userSetForms)_parentWindow.userSetForms = {};
            _parentWindow.userSetForms[window.menuItemId + "." + window.formId] = _userSetForm;
            _parentWindow.reOpenCurrentForm();
			
		}
		else
		{
			Warn.show({text:"加载失败"});
		}
	}

	fault_deleteUserSetListHandler(arg,data)
	{
		let row = arg.row;
		let rows=this.userSetList.state.rows.slice();
		rows.splice(arg.index,0,row)
		this.userSetList.setState({rows:rows});

		var faultString;
		if(data && data.successButNot0)
		{
			faultString = data.errText;
		}
		else
		{
			faultString = "可能是网络错误 请检查网络是否正常";
		}
		Warn.show({text:faultString,title:"删除失败"})
	}

	filterCurrentUser(e)
	{
		let _parentWindow = window.parent.window;
		let defaultUser=_parentWindow.userInfos.userId;
		this.userSetList.filterCurrentUser(defaultUser);
		$(this.btnFilterCurrentUser).hide();
    	$(this.btnCancelFilterCurrentUser).show();
	}

	cancelFilterCurrentUser(e)
	{
		this.userSetList.cancelFilterCurrentUser();
		$(this.btnFilterCurrentUser).show();
    	$(this.btnCancelFilterCurrentUser).hide();
	}

	setDefault(e)
	{
		let item = this.userSetList.getSelectedRow();
		if(item)
		{
	        let userId = item.userName;
	        let fileName = item.fileName;
	        
	        var command = Command.createService( 
	          "gongqi.erp.gotmodel.services.UserSettingService", 
	          "setUserDefaultFormDesign", 
	          "String"
	        );

	        let _parentWindow = window.parent.window;
			let slipper = ".";
			if(window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1)
				slipper = "&";
	       
	        command.appendArg(window.formId + slipper + window.menuItemId);
	        command.appendArg(_parentWindow.userInfos.userId);
	        
	        command.appendArg(userId);
	        command.appendArg(fileName);
	        
	        ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_setDefaultSetHandler.bind(this,fileName)});
		}
	}

	rpc_setDefaultSetHandler(defaultItem,data)
	{
		$("#userSetListDefaultItem").text("当前默认值"+defaultItem).attr("name",defaultItem);
		$("#cancelUserSetListDefaultItem").show();
		//alert("设置成功");
	}

	btnUnSetDefault_clickHandler(event)
	{	
		if($("#userSetListDefaultItem").text() == this.noSetLabel)
			return;
		var command = Command.createService("gongqi.erp.gotmodel.services.UserSettingService", "unsetUserDefaultFormDesign", "void");
		let slipper = ".";
		if(window.formId.indexOf(".") != -1 || window.menuItemId.indexOf(".") != -1)
			slipper = "&";
		command.appendArg(window.formId + slipper + window.menuItemId);
		command.appendArg(window.parent.window.userInfos.userId);
		
		ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_unSetDefaultHandler.bind(this)});	
	    
		
	}
	
	rpc_unSetDefaultHandler(event)
	{	
		$("#userSetListDefaultItem").text(this.noSetLabel);
		//delete window.parent.window.userSetForms[window.menuItemId + "." + window.formId];
	}

	render(){

		let _title = window.formModuleInstance.formLabel + " id=" + window.formModuleInstance.formId + " name=" + window.formModuleInstance.formName;
		let userInfos = window.userInfos?window.userInfos:(window.parent.window && window.parent.window.userInfos?window.parent.window.userInfos:null);
		let isAdmin = userInfos?userInfos.isAdmin:false;
		return(

			<div ref={node=>this.outterDiv=node} style={{alignSelf:"center",borderRadius:"2px",backgroundColor:'white',width:'900px',height:'520px',display:'flex',flexDirection:'column',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)'}}>
		      <div className="modal-header" style={{background:"#ffffff",padding:"10px",position:"relative",paddingTop:'13px',paddingBottom:'13px',backgroundColor:'#F8F8F8'}}>
		      	<div className="modal-close" onClick={this.closeUserSetForm.bind(this)}></div>
		        <h5 className="modal-title" style={{fontFamily:'STSongti-SC-Bold',fontSize:'16px',color:'#000000',fontWeight:'500 !IMPORTANT'}}>界面调整&nbsp;&nbsp;&nbsp;{_title}</h5>
		      </div>
		      <div style={{display:'flex',flexDirection:'column',flexGrow:100}}>
		       	<div style={{display:'flex',flexDirection:'row',flexGrow:100,boxShadow:'0 1px 1px rgba(0, 0, 0, 0.1)',borderRadius:'3px'}}>
		       		<div style={{display:'flex',flexDirection:'column',width:'300px',overflow:'auto',maxHeight:'420px',background:'#FAFAFA',boxShadow:'1px 0 0 0 rgba(203,203,203,0.50)',paddingTop:'12px',paddingRight:'2px'}}>
		       			<UserSetFormTree ref={node=>this.formTree=node}/>
		       		</div>
		       		<div style={{display:'flex',flexDirection:'column',flexGrow:2,marginLeft:'5px',marginRight:'5px',paddingLeft:'20px',overflow:'auto'}}>
		       			<UserSetFormPropertyPanel ref={node=>this.propertyPanel=node} allUserProperties={this.props.columnProperties} allColWidth={this.state.columnWidthProperties}/>
						   {/* <UserSetFormPropertyPanel ref={node=>this.propertyPanel=node} /> */}
		       		</div>
		       	</div>
		       	<div style={{display:'flex',flexDirection:'horizontal',flexGrow:0,flex:'0 0 auto',height:'50px',alignItems:'center',paddingRight:'22px',paddingLeft:'22px'}}>
		       		<button type="button" className="btn btn-info" style={{paddingLeft:'21px !important',fontFamily:'STSongti-SC-Bold',fontSize:'14px',textAlign:'center',marginRight:'9px',width:'88px',height:'32px',marginTop:'-2px'}} onClick={this.save.bind(this,'singleUser')}><i style={{color:'##0178D4',marginTop:'4px',float:'left',marginLeft:'7px'}} className="fa fa-download" aria-hidden="true"></i>保存</button>
          			<button type="button" className="btn btn-info" style={{paddingLeft:'21px !important',fontFamily:'STSongti-SC-Bold',fontSize:'14px',marginRight:'9px',width:'118px',height:'32px',marginTop:'-2px'}} onClick={this.btnLoadDefault_clickHandler.bind(this)}><i style={{color:'##0178D4',marginTop:'3px',float:'left',marginLeft:'7px'}} className="fa fa-spinner" aria-hidden="true"></i>加载默认</button>
          			<button type="button" className="btn btn-info" style={{paddingLeft:'21px !important',fontFamily:'STSongti-SC-Bold',fontSize:'14px',marginRight:'9px',width:'88px',height:'32px',marginTop:'-2px'}} onClick={this.showUserSetForm.bind(this)}><i style={{color:'##0178D4',marginTop:'3px',float:'left',marginLeft:'7px'}} className="fa fa-cog" aria-hidden="true"></i>设置</button>
          			<button type="button" className="btn btn-info" style={{paddingLeft:'21px !important',fontFamily:'STSongti-SC-Bold',fontSize:'14px',marginRight:'5px',width:'88px',height:'32px',marginTop:'-2px'}} onClick={this.resetForm.bind(this)}><i style={{color:'##0178D4',marginTop:'3px',float:'left',marginLeft:'7px'}} className="fa fa-repeat" aria-hidden="true"></i>复位</button>
          			<button type="button" className="btn btn-info" style={{paddingLeft:'21px !important',fontFamily:'STSongti-SC-Bold',fontSize:'14px',marginRight:'5px',width:'118px',height:'32px',marginTop:'-2px'}} onClick={this.resetColProperties.bind(this)}><i style={{color:'##0178D4',marginTop:'3px',float:'left',marginLeft:'7px'}} className="fa fa-edit" aria-hidden="true"></i>提取列宽</button>
          			<div style={{flexGrow:100}}></div>
					<button type="button" className="btn btn-info ufs-cancel" style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px'}} onClick={this.closeUserSetForm.bind(this)}>取消</button>
          			<button type="button" className="btn btn-info ufs-require" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623'}} onClick={this.reqUserSetForm.bind(this)}>确认</button>
		       	</div>
		      </div>


		      	<div className="modal" id="userFormSetSaveModal" key="saveModal" style={{zIndex: '2000'}} ref={node=>this.userFormSetSaveDiv=node}> 
				    <div className="modal-dialog" style={{marginTop:'100px',width:'640px'}}>
			            <div className="modal-content" style={{
							    background:'#FFFFFF',
								border: '1px solid #9B9B9B',
								boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)',
								borderRadius: '2px'
						}}>
			              <div className="modal-header">
			               
							<div className="modal-close" onClick={this.hideUserFormSetSaveTable.bind(this)}></div>
			                <h4 className="modal-title" style={{marginTop:'0',marginBottom:'0'}}>保存</h4>
			              </div>
			              <div className="modal-body" style={{display:'flex',flexDirection:'column',padding:'40px 10px'}} >
								<div style={{flexGrow:0,textAlign:'center'}} >
							  		<div style={{display:'flex',flexDirection:'row',paddingLeft:'35px'}}>
									  <div style={{textAlign:'right'}} >
										<label style={{paddingTop:'8px',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',fontWeight:'normal'}} >文件名：</label> 
							  		  </div>
							  		  <div style={{textAlign:'left',flexGrow:1,marginRight:'10px'}}>
										<input type="text" spellcheck="false" className="form-control" id="userSetFormSaveFileName"/>
									  </div>
									</div>
								</div>
								<div style={{flexGrow:1,textAlign:'center',paddingLeft:'83px'}} >
									<div style={{display:'flex',flexDirection:'row'}} >
										<div style={{display:'flex',alignItems:'center',textAlign:'left',position:'relative'}} >
											<input type="checkbox" id="userSetDefaultBox" style={{width:'16px',height:'16px'}}/>
											<label htmlFor="userSetDefaultBox"></label>
										</div>
										<div style={{textAlign:'right',paddingLeft:'3px'}}>
											<label style={{paddingTop:'3px',fontSize:'14px',fontFamily:'STSongti-SC-Regular',color:'#4A90E2',marginRight:'10px'}} >设为默认</label>
										</div>

										<div style={{display:isAdmin?'flex':'none',alignItems:'center',textAlign:'left',position:'relative'}} >
											<input type="checkbox" id="userSetDefaultBoxAll" ref={node=>this.userSetDefaultBoxAll=node} style={{width:'16px',height:'16px'}}/>
											<label htmlFor="userSetDefaultBoxAll"></label>
										</div>
										<div style={{textAlign:'right',paddingLeft:'3px',display:isAdmin?'flex':'none'}}>
											<label style={{paddingTop:'3px',fontSize:'14px',fontFamily:'STSongti-SC-Regular',color:'#4A90E2'}} >为所有用户保存</label>
										</div>
										
									</div>
								</div>
			              </div>
			              <div className="modal-footer" style={{padding:'10px 15px'}}>
			                <button type="button" className="btn" style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}} id="userFormSetSaveModal_BtnCancel" data-dismiss="modal" onClick={this.hideUserFormSetSaveTable.bind(this)}>取消</button>
			                <button type="button" className="btn" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px',color:'#fff'}} onClick={this.saveUserSetForm.bind(this)}>保存</button>
			              </div>
			            </div>
			        </div>
			  	</div>

		  		<div className="modal" id="userSetTable" style={{zIndex: '2000',display: 'none'}}>
			    	<div className="modal-dialog" style={{width: '600px',backgroundColor: '#fff'}}>
						<div className="modal-content" style={{marginTop:'80px',background:'#FFFFFF',border:'0 solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
				        	<div className="modal-header">
								<div className="modal-close" onClick={this.hideUserSetTable.bind(this)}></div>
					          	<h5 className="modal-title" style={{fontWeight:'bolder'}}>已保存列表</h5>
				          	</div>
				          	<div className="modal-content">
					          	<div className="box" style={{borderTop: '1px solid #d2d6de',textAlign:'center'}}>
					            	<div className="box-header with-border" style={{textAlign:'left',background:'#FAFAFA',marginLeft:'10px',marginRight:'10px',height:'40px',borderLeft:'solid 3px #0178D4',paddingTop:'10px',display:'flex',alignItems:'center',borderBottom:'none'}}>
					            		<span className="box-title" id="userSetListDefaultItem" style={{marginLeft:'10px',fontSize:'14px',fontWeight:'inherit'}}></span>
										<button type="button" id="cancelUserSetListDefaultItem" className="btn btn-info" data-dismiss="modal" onClick={this.btnUnSetDefault_clickHandler.bind(this)}>取消</button>
					              		
					            	</div>
					            	<div className="box-body" style={{height: '290px'}}>
								 		<div style={{width:'100%',height:'100%'}}>
					              			<UserSetListDataGrid ref={node=>this.userSetList = node}/>
										</div>
					            	</div>

					            	<div className="box-footer" id="userSetTable-footer" style={{marginTop:'5px',textAlign:'right',borderTop:'1px solid rgba(0,0,0,0.10)'}}>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.resetUserSetTable.bind(this)} style={{marginLeft:'5px',marginRight:'0'}}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-spinner"></i>加载</button>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.deleteUserSetList.bind(this)} style={{marginLeft:'8px',marginRight:'0'}}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-trash-o" aria-hidden="true"></i>删除</button>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.filterCurrentUser.bind(this)} ref={node => this.btnFilterCurrentUser=node} style={{marginLeft:'8px',marginRight:'0'}}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-filter" aria-hidden="true"></i>筛选当前用户</button>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" style={{display: 'none',marginLeft:'8px',marginRight:'0'}} onClick={this.cancelFilterCurrentUser.bind(this)} ref={node => this.btnCancelFilterCurrentUser=node}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-filter" aria-hidden="true"></i>取消筛选</button>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.setDefault.bind(this)} ref={node=>this.btnSetDefault = node} style={{marginLeft:'8px',marginRight:'0'}}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-cog" aria-hidden="true"></i>设为默认</button>
					            	</div>
					         	</div>
					        </div>
				        </div>
				  	</div>
				</div>

		    </div>

		)
	}

}


// WEBPACK FOOTER //
// ./src/userformset/UserFormSetForm.js